<template>
  <div class="invoice-delay-receive">
    <div class="item-title">{{ $t('components_invoice_delay_receive.zhang_dan_lie_biao') }}</div>
    <div class="header">
      <div class="btn-container">
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="!isLockBill && canAddPayableOrder"
          @click="addPayableOrder"
        >{{ $t('components_invoice_delay_receive.tian_jia_zhang_dan') }}</el-button>
      </div>
    </div>
    <div class="table-bd">
      <custom-table
        index
        :data="tableList"
        tableCode="invoice_delay_receive"
        :slots="['newDelayDays', 'termNum', 'expectedExpirationDate', 'action']"
        :filterArr="canAddPayableOrder ? [] : ['action']"
      >
        <template v-slot:expectedExpirationDate="scope">
          {{ countExpDate(scope.row) }}
        </template>
        <template
          slot="newDelayDays"
          slot-scope="scope"
        >
          <el-input
            type="number"
            :disabled="model.type === 'watch'"
            v-model="scope.row.newOverdueDays"
            style="width: 97%"
            :placeholder="scope.$index > 0 ? $t('components_invoice_delay_receive.tong_shang') : ''"
          ></el-input>
        </template>
        <template v-slot:termNum="scope">
          {{scope.row.termNum}}/{{scope.row.totalTerm}}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <el-button
            v-if="scope.$index > 0"
            type="text"
            size="mini"
            @click="onDel(scope.row)"
          >{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <!-- <div class="org-data">
      <div class="item">{{ $t('pid_receive_fu_kuan_fang') }}: {{payableOrgName}}</div>
      <div class="item">{{ $t('pid_receive_shou_kuan_fang') }}: {{receivableOrgName}}</div>
    </div> -->
    <div
      class="item-title"
      style="margin-top: 15px"
    >{{ $t('components_invoice_delay_receive.shen_qing_yuan_yin') }}</div>
    <el-form
      :model="form"
      ref="form"
      label-width="auto"
      :rules="rules"
    >
      <el-form-item prop="changeDesc">
        <el-input
          type="textarea"
          :disabled="model.type === 'watch'"
          :rows="4"
          placeholder=""
          v-model="form.changeDesc"
          style="width: 100%"
        ></el-input>
      </el-form-item>
    </el-form>
    <!-- 只有租赁账单可以延期, 所以延期付款的添加账单需要限制billType -->
    <accounts-add-account-dialog
      v-if="dialog1Visible"
      @close="dialog1Visible = false"
      :model="dialog1Model"
      @confirm="onAddConfirm"
      :paymentOrReceivable="paymentOrReceivable"
      :requestBillType="['10']"
    ></accounts-add-account-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';
import accountsAddAccountDialog from '@/pages/fms/components/accounts_add_account_dialog';

export default {
  mixins: [languageInjectMixins],
  components: { accountsAddAccountDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '',
          row: [], // 非必传，新增用
        };
      },
    },
    isLockBill: {
      type: Boolean,
      default: false,
    },
    canAddPayableOrder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableList: [],
      form: {
        changeId: '',
        changeBillList: [],
        changeDesc: '',
      },
      // receive-收款  pay-付款
      // pageType: 'receive',
      firstItem: {},
      dialog1Visible: false,
      dialog1Model: {},
      // 添加账单时需要判断是收款还是付款， 目前通过外部传入的table item 判断
      paymentOrReceivable: false,
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
      };
    },
    payableOrgName() {
      const tableList = this.tableList || [];
      return tableList && tableList.length ? tableList[0].payableOrgName : '';
    },
    receivableOrgName() {
      const tableList = this.tableList || [];
      return tableList && tableList.length ? tableList[0].receivableOrgName : '';
    },
  },
  mounted() {
    if (this.model.row) {
      this.tableList = Array.isArray(this.model.row) ? this.model.row : [this.model.row];
      this.firstItem = this.tableList[0];
      this.paymentOrReceivable = this.firstItem.paymentOrReceivable || false;
    }

    this.getDetail();
  },
  methods: {
    onAddConfirm(arr) {
      arr.forEach((item) => {
        item.depositFee = 0;
      });
      this.tableList.push(...arr);
    },
    addPayableOrder() {
      this.dialog1Model = {
        type: 'add',
        data: {
          ...this.firstItem,
          billTradeState: 0,
          filterBillIdList: this.tableList.map((item) => item.billId),
        },
      };
      this.dialog1Visible = true;
    },
    // 获取编辑详情
    getDetail: function () {
      if (this.model.changeId) {
        this.$getJSON(`${apis.OverdueInfo}/${this.model.changeId}`).then((res) => {
          this.tableList = res.data.billViewList;
          this.form.changeId = res.data.changeId;
          this.form.changeDesc = res.data.changeDesc;
        });
      }
    },

    // 计算：预计到期日期
    countExpDate(row) {
      // 预计到期日期= 账单到期日期+新延期天数
      // 账单到期日期 billPaymentTime
      // 新延期天数 newDelayDays
      const { billPaymentTime } = row;
      const newDelayDays = row.newOverdueDays;

      if (billPaymentTime && newDelayDays && `${newDelayDays}`.length) {
        const time = new Date(billPaymentTime);
        const days = Number(newDelayDays);
        const day = 24 * 3600 * 1000;
        const totalMs = time.getTime() + days * day;
        const retDate = new Date(totalMs);

        const ret = this.$momentLocal(retDate, 'YYYY-MM-DD');

        return ret;
      }

      return '-';
    },

    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      const tableList = this.$formatCopyUp(this.tableList, ['newOverdueDays']);
      const hasEmpty = tableList.find((t) => !t.newOverdueDays && t.newOverdueDays !== '0');
      if (hasEmpty) {
        this.$message.error(this.$t('components_invoice_delay_receive.qjsjtxwz'));
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.changeBillList = tableList.map((t) => ({ billId: t.billId, overdueDays: t.newOverdueDays }));
        const arr = tableList.map((t) => t.bodyNum);
        const len = [...new Set(arr)].length;
        if (len > 100) {
          this.$message.error(this.$t('components_invoice_delay_receive.sqsbslbncg100t'));
          return;
        }
        this.$postJSON(apis.OverdueSave, this.form).then((res) => {
          if (approve) {
            this.onSubmit(res.data);
            return;
          }
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success', this.form);
        });
      });
    },
    // 提交审批
    onSubmit(row) {
      const typeText = this.getDicValue('approval_type', 'deferred');
      this.$postJSON(
        `${apis.apsApproveApprovalApproveStart}/deferred/${row.changeId}`,
        {
          title: [`【${row.changeId}】`, typeText].join(' '),
          applyReason: row.changeDesc,
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success', this.form);
      });
    },
    // 删除
    onDel(row) {
      this.tableList = this.tableList.filter((item) => item.billId !== row.billId);
    },
  },
};
</script>

<style lang="scss">
.invoice-delay-receive {
  .btn-container {
    padding-bottom: 16px;
  }
  .org-data {
    overflow: hidden;
    padding: 10px 0;

    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);

    .item {
      margin-top: 20px;
      font-size: 12px;
    }
  }
}
</style>
